export default __webpack_public_path__ + "static/media/protection.838e733b.png";